import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { AgentLoginService, currentComponentPageBasedPermissionsSelector$, fileUrlDownload } from '@app/shared';
import { ResponseMessageTypes } from '@app/shared/enums';
import { CrudService, RxjsService, SnackbarService } from '@app/shared/services';
import { TableFilterFormService } from '@app/shared/services/create-form.services';
import { MomentService } from '@app/shared/services/moment.service';
import {
  CommonPaginationConfig,
  CrudType,
  LoggedInUserModel, ModulesBasedApiSuffix,
  NO_DATA_FOUND_MESSAGE,
  PERMISSION_RESTRICTION_ERROR,
  addDefaultTableObjectProperties,
  columnFilterRequestUtil,
  debounceTimeForSearchkeyword,
  loadPaginationLazy,
  prepareDynamicTableTabsFromPermissions,
  prepareRequiredHttpParams
} from '@app/shared/utils';
import { MyRawLeadAddRawLeadsNotesModalComponent } from '@modules/my-tasks';
import { MY_TASK_COMPONENT } from '@modules/my-tasks/shared';
import { loggedInUserData, selectStaticEagerLoadingLeadGroupsState$, selectStaticEagerLoadingLeadStatusState$, selectStaticEagerLoadingRawLeadStatusState$, selectStaticEagerLoadingSiteTypesState$ } from '@modules/others';
import { LeadHeaderDataCreateAction } from '@modules/sales';
import { RawLeadStatuses, SalesModuleApiSuffixModels } from '@modules/sales/shared';
import { Store } from '@ngrx/store';
import { ChangeStatusModalComponent } from '@sales/components/raw-lead';
import { combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-my-tasks-list',
  templateUrl: './my-tasks-list.component.html',
  styleUrls: ['./my-tasks-list.component.scss']
})
export class MyLeadTaskListComponent extends PrimeNgTableVariablesModel implements OnInit {
  customerId: string = '';
  columnFilterForm: FormGroup;
  searchColumns;
  searchForm: FormGroup;
  siteTypes;
  group;
  request;
  leadStatuses = [];
  rawLeadStatuses = [];
  NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;

  primengTableConfigProperties: any = {
    tableCaption: "My Tasks List",
    breadCrumbItems: [{ displayName: 'My Tasks' }, { displayName: 'My Sales' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'My Unqualified Leads',
          dataKey: 'rawLeadId',
          columns: [{ field: 'rawLeadRefNo', header: 'Unqualified Lead ID', width: '200px' },
          { field: 'client', header: 'Client', width: '200px' },
          { field: 'email', header: 'Email Address', width: '300px' },
          { field: 'phoneNumber', header: 'Phone Number', width: '200px' },
          { field: 'sourceCode', header: 'Source Code', width: '200px' },
          { field: 'suburb', header: 'Suburb ', width: '200px' },
          { field: 'callAttempts', header: 'Call Attempts', width: '200px' },
          { field: 'siteType', header: 'Site Type', width: '300px' },
          { field: 'loadDate', header: 'Load Date', width: '200px' },
          { field: 'iconClass', header: 'Notes', width: '200px' },
          { field: 'status', header: 'Status', width: '200px' },
          ],
          apiSuffixModel: SalesModuleApiSuffixModels.SALES_API_LEAD_CATEGORIES,
          moduleName: ModulesBasedApiSuffix.SALES,
        },
        {
          caption: 'My Leads',
          dataKey: 'leadId',
          columns: [{ field: 'leadRefNo', header: 'Lead Number' },
          { field: 'clientName', header: 'Name', isHtmlContent: true, isHtmlTooltip: true },
          { field: 'suburbName', header: 'Suburb' },
          { field: 'leadGroupName', header: 'Lead Group' },
          { field: 'siteTypeName', header: 'Site Type' },
          { field: 'callDateTime', header: 'Call Time' },
          { field: 'leadStatusName', header: 'Status' }],
          apiSuffixModel: SalesModuleApiSuffixModels.SALES_API_LEADS_MY_LEADS,
          moduleName: ModulesBasedApiSuffix.SALES,
        },
        {
          caption: 'My Quote Follow-Up',
          dataKey: 'leadCallbackId',
          columns: [{ field: 'leadCallbackRefNo', header: 'FollowUp ID' },
          { field: 'leadNumber', header: 'Lead Number' },
          { field: 'quotationNumber', header: 'Quote Number' },
          { field: 'probabilityOfClosureName', header: 'Probability of Closure', width: "250px" },
          { field: 'timeOfDeal', header: 'Time of Deal' },
          { field: 'callbackDateTime', header: 'Follow-up Date and Time', width: "250px" },
          { field: 'notes', header: 'Notes' }],
          apiSuffixModel: SalesModuleApiSuffixModels.SALES_API_QUOTE_FOLLOW_UPS,
          moduleName: ModulesBasedApiSuffix.SALES,
        },
        {
          caption: 'My Stop And Knock',
          dataKey: 'stopAndKnockId',
          columns: [{ field: 'stopAndKnockRefNo', header: 'SK ID' },
          { field: 'suburbName', header: 'Suburb' },
          { field: 'cityName', header: 'City' },
          { field: 'reconnectionArea', header: 'Reconn Area' },
          { field: 'agent', header: 'Agent' },
          { field: 'agentMobileNumber', header: 'Agent Mobile Number' },
          { field: 'agentFollowupDate', header: 'Agent Followup Date' },
          { field: 'seller', header: 'Seller' },
          { field: 'sellerFollowupDate', header: 'Seller Followup Date' },
          { field: 'contactPersonType', header: 'Contact Person Type' },
          { field: 'mobileNo1', header: 'MobileNo1' },
          { field: 'createdDate', header: 'Created Date' }
          ],
          apiSuffixModel: SalesModuleApiSuffixModels.STOP_KNOCK,
          moduleName: ModulesBasedApiSuffix.SALES,
        }
      ]
    }
  }

  constructor(private httpService: CrudService, private tableFilterFormService: TableFilterFormService,
    private dialog: MatDialog, private activatedRoute: ActivatedRoute, private crudService: CrudService,
    private rxjsService: RxjsService, private _fb: FormBuilder, private momentService: MomentService, private agentLoginService: AgentLoginService,
    private snackbarService: SnackbarService, private router: Router, private store: Store<AppState>) {
    super();
    this.searchForm = this._fb.group({ searchKeyword: "" });
    this.columnFilterForm = this._fb.group({});
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties, [{
      index: 2, propertyName: 'enableAddActionBtn'
    }, {
      index: 3, propertyName: 'enableAddActionBtn'
    }]);
  }

  combineLatestNgrxStoreData(): void {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(selectStaticEagerLoadingLeadGroupsState$),
      this.store.select(selectStaticEagerLoadingSiteTypesState$),
      this.store.select(selectStaticEagerLoadingLeadStatusState$),
      this.store.select(selectStaticEagerLoadingRawLeadStatusState$), this.store.select(selectStaticEagerLoadingLeadGroupsState$),
      this.store.select(selectStaticEagerLoadingSiteTypesState$), this.activatedRoute.queryParams,
      this.store.select(currentComponentPageBasedPermissionsSelector$)
    ]
    ).pipe(take(1)).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.group = response[1];
      this.siteTypes = response[2];
      this.leadStatuses = response[3];
      this.rawLeadStatuses = response[4];
      this.group = response[5];
      this.siteTypes = response[6];
      if (response[8][MY_TASK_COMPONENT.MY_SALES]) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, response[8][MY_TASK_COMPONENT.MY_SALES]);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
        if (Object.keys(response[7]).length > 0) {
          this.selectedTabIndex = response[7]?.setindex ? +response[7]?.setindex : response[7]?.tab ? +response[7]?.tab : 0;
          this.onCRUDRequested(CrudType.GET, {});
        }
        else {
          this.selectedTabIndex = +prepareDynamicTableTabsFromPermissionsObj['selectedTabIndex'];
        }
        this.prepareLastBreadcrumbSegment();
      }
    });
  }

  prepareLastBreadcrumbSegment() {
    this.primengTableConfigProperties.breadCrumbItems[2] = {
      displayName: this.selectedTabIndex == 0 ? 'My Unqualified Leads' :
        this.selectedTabIndex == 1 ? 'My Leads' : this.selectedTabIndex == 2 ? 'My Quote FollowUp' : 'My Stop And Knock'
    };
  }

  ngOnInit(): void {
    this.requestParams = {
      pageIndex: CommonPaginationConfig.defaultPageIndex,
      maximumRows: CommonPaginationConfig.defaultPageSize
    };
    this.combineLatestNgrxStoreData();
    this.prepareLastBreadcrumbSegment();
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns);
    this.columnFilterValueChanges();
    this.prepareTabBasedServerRequests();
    this.rxjsService.setCustomerContactNumber(null);
  }

  checkIfCustomerDetails(customerNumber, details) {
    if (!customerNumber && details.length != 0) {
      return true;
    } else {
      return false;
    }
  }

  columnFilterValueChanges() {
    this.columnFilterForm.valueChanges.pipe(debounceTime(debounceTimeForSearchkeyword),
      distinctUntilChanged()).subscribe((formObject) => {
        let replaceableKeyAndValues = this.selectedTabIndex == 0 ?
          [{ actualNameKey: 'status', alternateNameKey: 'rawLeadStatusId', alternateValueKey: 'id' },
          { actualNameKey: 'siteType', alternateNameKey: 'siteTypeId', alternateValueKey: 'id' }] :
          this.selectedTabIndex == 1 ? [{ actualNameKey: 'leadStatusName', alternateNameKey: 'LeadStatusId', alternateValueKey: 'id' },
          { actualNameKey: 'siteTypeName', alternateNameKey: 'siteTypeId', alternateValueKey: 'id' },
          { actualNameKey: 'leadGroupName', alternateNameKey: 'LeadGroupId', alternateValueKey: 'id' }] : [];
        // utitlize the common column filter util method
        columnFilterRequestUtil(this.row, this.onCRUDRequested.bind(this), replaceableKeyAndValues, formObject, this.momentService)
      });
  }

  loadPaginationLazy(event) {
    this.row = loadPaginationLazy(event);
    columnFilterRequestUtil(this.row, this.onCRUDRequested.bind(this), this.requestParams);
  }

  getMyRawLeads() {
    this.httpService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_MY_RAW_LEADS,
      undefined,
      false,
      prepareRequiredHttpParams(this.requestParams)
    ).subscribe((resp) => {
      if (resp.resources && resp.statusCode == 200 && resp.isSuccess) {
        resp.resources.forEach((resp) => {
          resp['iconClass'] = 'icon icon-inventory';
        });
        this.dataList = resp.resources;
        this.totalRecords = resp.totalCount;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, requestParams?, cursorLinkIndex = 0, field = null): void {
    this.requestParams = requestParams;
    if (field) {
      switch (field) {
        case "leadCallbackRefNo":
          break;
        case "leadNumber":
          this.rxjsService.setFromUrl("My Leads List");
          this.router.navigate(['/my-tasks/my-sales/my-leads/lead-info/view'], { queryParams: { leadId: row['leadId'] } });
          break;
        case "quotationNumber":
          this.openDocument(row['documentPath']);
          break;
      }
    }
    else {
      switch (type) {
        case CrudType.CREATE:
          this.openAddEditPage(CrudType.CREATE, row);
          break;
        case CrudType.GET:
          this.prepareTabBasedServerRequests();
          break;
        case CrudType.EDIT:
          this.openAddEditPage(CrudType.EDIT, row, cursorLinkIndex);
          break;
        case CrudType.ICON_POPUP:
          if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
            this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
          }
          else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
            this.addNotes(row);
          }
          break;
        case CrudType.STATUS_POPUP:
          if (this.selectedTabIndex == 0 || this.selectedTabIndex == 1) {
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            this.changeStatus(row);
          }
          break;
      }
    }
  }

  prepareTabBasedServerRequests() {
    this.requestParams = typeof this.requestParams === 'undefined' ? {} : this.requestParams;
    this.requestParams['userId'] = this.loggedInUserData.userId;
    switch (this.selectedTabIndex) {
      case 0:
        this.getMyRawLeads();
        break;
      case 1:
        this.getMyLeads();
        break;
      case 2:
        this.requestParams['createdUserId'] = this.loggedInUserData.userId;
        this.getMyTasksQuoteFollowUp();
        break;
      case 3:
        this.getMyStopAndKnocks();
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, cursorLinkIndex = 0): void {
    switch (type) {
      case CrudType.CREATE:
        switch (this.selectedTabIndex) {
          case 0:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
              this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
              this.router.navigate(['/my-tasks/my-sales/my-unqualified-leads/add-edit']);
              this.rxjsService.setFromUrl("My Unqualified Leads List");
            }
            break;
          case 1:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
              this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
              this.router.navigate(['/my-tasks/my-sales/my-leads/lead-info/add-edit']);
              this.store.dispatch(new LeadHeaderDataCreateAction({ leadHeaderData: { fromUrl: 'My Leads List' } }));
              this.rxjsService.setFromUrl("My Leads List");
            }
            break;
        }
        break;
      case CrudType.EDIT:
        switch (this.selectedTabIndex) {
          case 0:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              this.router.navigate(['/my-tasks/my-sales/my-leads/lead-info/add-edit'], { queryParams: { rawLeadId: editableObject['rawLeadId'] } });
              this.rxjsService.setFromUrl("My Unqualified Leads List");
            }
            break;
          case 1:
            this.router.navigate(['/my-tasks/my-sales/my-leads/lead-info/view'], { queryParams: { leadId: editableObject['leadId'], selectedIndex: 1 } });
            this.rxjsService.setFromUrl("My Leads List");
            break;
          case 3:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            else if (this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              this.router.navigate(['/my-tasks/my-sales/my-stop-and-knocks/add-edit'], { queryParams: { stopAndKnockId: editableObject['stopAndKnockId'] } })
              this.rxjsService.setFromUrl("My Stop And Knock List");
            }
            break;
        }
        break;
    }
  }

  getMyLeads() {
    this.httpService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_LEADS_MY_LEADS,
      undefined,
      false,
      prepareRequiredHttpParams(this.requestParams)
    ).subscribe(resp => {
      this.dataList = resp.resources;
      this.totalRecords = resp.totalCount;
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  getMyTasksQuoteFollowUp() {
    this.httpService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_QUOTE_FOLLOW_UPS,
      undefined,
      false,
      prepareRequiredHttpParams(this.requestParams)
    ).subscribe(resp => {
      this.dataList = resp.resources;
      this.totalRecords = resp.totalCount;
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  getMyStopAndKnocks(): void {
    this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.STOP_KNOCK,
      undefined,
      false,
      prepareRequiredHttpParams(this.requestParams)
    ).subscribe(response => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources;
        this.totalRecords = response.totalCount;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onTabChange(e): void {
    this.selectedTabIndex = e.index;
    this.requestParams = {
      pageIndex: CommonPaginationConfig.defaultPageIndex,
      maximumRows: CommonPaginationConfig.defaultPageSize
    };
    this.prepareLastBreadcrumbSegment();
    this.row = {};
    this.columnFilterForm = this._fb.group({})
    this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[e.index].columns);
    this.columnFilterValueChanges();
    this.totalRecords = null;
    this.dataList = null;
    this.router.navigate(['/my-tasks', 'my-sales'], { queryParams: { tab: this.selectedTabIndex } });
    setTimeout(() => {
      this.prepareTabBasedServerRequests();
    }, 100)
  };

  addNotes(data) {
    if (this.selectedTabIndex == 0) {
      this.dialog.open(MyRawLeadAddRawLeadsNotesModalComponent, { width: '700px', disableClose: true, data })
    }
  }

  changeStatus(data) {
    if (data.rawLeadStatusId == RawLeadStatuses.Address_Verification_Pending || data.rawLeadStatusId == RawLeadStatuses.Lead_Created) {
      return;
    }
    else if (data.rawLeadStatusId) {
      const dialogReff = this.dialog.open(ChangeStatusModalComponent, { width: '700px', disableClose: true, data });
      dialogReff.afterClosed().subscribe(result => {
        if (result) return;
        if (this.selectedTabIndex == 0) {
          this.getMyRawLeads();
        }
      });
      this.rxjsService.setGlobalLoaderProperty(false);
    }
  }

  contactNumber(contact) {
    if (this.selectedTabIndex == 0) {
      if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
        this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
      }
      else {
        let data = {
          customerContactNumber: contact.phoneNumber,
          rawLeadId: contact.rawLeadId,
          clientName: contact.clientName
        };
        this.agentLoginService.initiateOutboundCall(data);
      }
    }
  }

  getFileName(filePath: string): string {
    if (!filePath) return 'download';
    const pathOnly = filePath.split('?')[0];
    return pathOnly.split('/').pop() || pathOnly.split('\\').pop() || 'download';
  }

  openDocument(documentPath: string): void {
    if (documentPath) {
      const fileName = this.getFileName(documentPath);
      fileUrlDownload(
        documentPath,
        fileName,
        false,
        this.crudService,
        this.rxjsService,
        true,
        'preview'
      ).catch(error => {
        console.error('Error opening document:', error);
        this.snackbarService.openSnackbar('Unable to open document', ResponseMessageTypes.ERROR);
      });
    }
  }
}